export default __webpack_public_path__ + "static/media/안주8.cf8843c6.png";